import React, { Component } from 'react'
import UserCard from './UserCard'
import UserForm from '../_Components/UserForm'
import RoleDetails from '../_Components/RoleDetails';
import PasswordChecklist from '../_Components/PasswordChecklist';

import { connect } from 'react-redux';
import { alertActions } from '../../../../_actions/alert.actions';
import { usersService } from '../../../../_services/users.service';
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import httpStatus from 'http-status';

class AddUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        role: '',
        title: '',
        username: '',
        roleId: null,
        lastName: '',
        password: null,
        userType: null,
        firstName: '',
        specialtyId: null,
        specialty: null,
        profileImage: null,
        credentials: null,
        publicIdentity: true,
      },
      errors: {},
      loading: false,
      setPassword: false,
      isElemFocused: false,
      isValidPassword: false,
      showRoleDetails: false,
      showPasswordChecklist: false
    }
    this.userType = ''
    this.userCardRef = React.createRef(null)
    this.roleDetailsRef = React.createRef(null)
    this.passwordChecklistRef = React.createRef(null)

    this.handleAdd = this.handleAdd.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
    this.handleSetState = this.handleSetState.bind(this)
    this.handleSetShowPassword = this.handleSetShowPassword.bind(this)
    this.handleCurrentlyFocused = this.handleCurrentlyFocused.bind(this)
    this.handleToggleRoleDetails = this.handleToggleRoleDetails.bind(this)
    this.handleTogglePasswordChecklist = this.handleTogglePasswordChecklist.bind(this)
  }

  componentDidMount() {
    const { history, dispatch } = this.props
    
    if (!history.location.state) {
      history.push('/account/users')
      
      return dispatch(alertActions.error('Please select the user type before continuing.'))
    }

    this.userType = history.location.state.userType

    this.setState({user: {
      ...this.state.user,
      userType: history.location.state.userType
    }})
  }

  handleSetState(value) {
    this.setState({
      user: {...this.state.user, ...value}
    })
  }

  handleSetShowPassword(value) {
    this.setState({ setPassword: value })
  }

  handleCancel() {
    this.props.history.push('/account/users')
  }

  handleAdd() {
    let errors = {}

    this.props.dispatch(alertActions.clear())

    if (this.state.user.firstName === '') {
      errors.firstName = 'Please enter a first name.'
    }
    if (this.state.user.lastName === '') {
      errors.lastName = 'Please enter a last name.'
    }
    if (this.state.user.userType === 'Licensed' && !this.state.user.specialtyId) {
      errors.specialtyId = 'Please select a specialty.'
    }
    if (!this.state.user.roleId) {
      errors.roleId = 'Please select a role.'
    }
    if (this.state.user.username === '') {
      errors.username = 'Please enter a username.'
    }
    if (this.state.setPassword) {
      if (this.state.isValidPassword === false) {
        errors.password = 'Password is invalid.'
      }
      if (this.state.user.password === '') {
        errors.password = 'Please enter a password.'
      }
    }

    this.setState({errors: errors})

    if (Object.values(errors).length === 0) {
      
      this.setState({loading: true})
      
      const { role, ...newUser } = this.state.user;

      usersService.addUser(newUser)
        .then((data) => {
          this.props.history.push(`/account/users/${data.userId}/welcome`)
        })
        .catch((error) => {
          if (error.response && error.response.status === httpStatus.UNPROCESSABLE_ENTITY) {
            this.setState({
              loading: false,
              errors: error.response.data.errors
            })

            this.props.dispatch(alertActions.error(error.response.data.message));
          } else {
            this.setState({loading: false})

            this.props.dispatch(alertActions.error('Could not add user at this time. Please try again.'));
          }
        });
    }
  }

  handleCurrentlyFocused(focused) {
    this.setState({isElemFocused: focused ? true : false})
    if (focused) {
      const offsetTop = document.getElementsByName(focused)[0].getBoundingClientRect().top
      this.userCardRef.current.style.top = (window.scrollY + offsetTop - 229) + 'px'
    }
  }

  handleToggleRoleDetails(value) {
    this.setState({showRoleDetails: value})
    const offsetTop = document.getElementsByName('role')[0].getBoundingClientRect().top
    this.roleDetailsRef.current.style.top = (window.scrollY + offsetTop - 229) + 'px'
  }

  handleTogglePasswordChecklist(value) {
    this.setState({showPasswordChecklist: value})
    const offsetTop = document.getElementsByName('password')[0].getBoundingClientRect().top
    this.passwordChecklistRef.current.style.top = (window.scrollY + offsetTop - 229) + 'px'
  }

  render() {
    return (
      <>
        <header className='mb-4'>
          <div className='lead py-2 text-capitalize'>Add {this.userType} User</div>
          <div className='font-weight-light'>
            Enter the {this.userType === 'Staff' ? "staff's " : "licensed user's "} 
            information below. An email will be sent to the user with their login information.
          </div>
        </header>

        <Row>
          <Col lg='10' xl='8'>
            <UserForm 
              state={this.state.user}
              errors={this.state.errors}
              userType={this.userType}
              password={this.state.user.password}
              setParentState={this.handleSetState}
              profileImage={this.state.user.profileImage}
              setPassword={this.state.setPassword}
              currentlyFocused={this.handleCurrentlyFocused}
              toggleRoleDetails={this.handleToggleRoleDetails}
              handleSetShowPassword={this.handleSetShowPassword}
              togglePasswordChecklist={this.handleTogglePasswordChecklist}
            >
              <Row className='mt-5'>
                <Col xs='3'>
                  <Button disabled={this.state.loading} onClick={this.handleCancel} block variant='outline-primary'>Cancel</Button>
                </Col>
                <Col xs={{span: 4, offset: 5}}>
                  <Button disabled={this.state.loading} onClick={this.handleAdd} block variant='success'>
                    { this.state.loading ? <Spinner size='sm' animation='border' /> : 'Add User'}
                  </Button>
                </Col>
              </Row>
            </UserForm>
          </Col>
          <Col>
            <div ref={this.roleDetailsRef} style={{position: 'sticky', top: 0}}>
              { this.state.showRoleDetails &&
                <RoleDetails role={this.state.user.role}/>
              }
            </div>

            <div ref={this.userCardRef} style={{position: 'absolute'}}>
              {this.state.isElemFocused && <UserCard 
                  lastName={this.state.user.lastName}
                  firstName={this.state.user.firstName}
                  profileImage={this.state.user.profileImage}
                  credentials={this.state.user.credentials}
                  publicIdentity={this.state.user.publicIdentity}
                >
                <Row>
                  {
                    this.userType === 'Staff' ?
                    <Col className='text-muted'>
                      {this.state.user.title ? 
                          <span>{this.state.user.title}</span> : 
                          <span className='font-italic'>Title</span>
                      }
                    </Col>
                    :
                    <Col className='text-muted'>
                      {this.state.user.specialty ? 
                          <span>{this.state.user.specialty}</span> : 
                          <span className='font-italic'>Specialty</span>
                      }
                    </Col>
                  }
                </Row>
              </UserCard>
              }
            </div>

            <div ref={this.passwordChecklistRef} style={{position: 'absolute', top: '655px'}}>
              {this.state.showPasswordChecklist &&
                <PasswordChecklist 
                  password={this.state.user.password} 
                  setIsValid={(value) => this.setState({isValidPassword: value})}
                />
              }
            </div>
          </Col>
        </Row>
      </>
    )
  }
}

export default connect()(AddUser);